export const PARENT_WINDOW_MESSAGE_TYPE = 'windowId';

export const EMBED_READY_MESSAGE_TYPE = 'narvar:track:ready';

export interface EarlyEmbedReporter {
  parentWindowId: string | null;
  parentWindowOrigin: string | null;
  stop: () => void;
}

declare global {
  interface Window {
    narvarTrackEmbed?: EarlyEmbedReporter;
  }
}
